module.exports = __webpack_public_path__ + "img/n-h-banner2.a00f615b.png";